import { accountIdFromPath } from "../util/accountId";
import authStore, {
    enterInspectFromEntry,
} from "./accessToken/observables/authStore";
import { authenticate } from "./auth";
import { getInspectToken } from "./inspectTokens";
import { getCognitoSession } from "./localStorage";

/**
 * Authenticate the base (logged-in) session, then resume inspect mode for this
 * tab if its `/:accountId` has a stored inspect token. Returns "app" to render
 * the app or "login" to show the login screen.
 */
export const bootstrapAuth = async (
    pathname: string,
): Promise<"app" | "login"> => {
    const baseSession = getCognitoSession();
    const authResult = await authenticate(baseSession);
    if (!authResult) {
        return "login";
    }

    authStore.dispatch("setAuthenticatedUser", { accountUser: authResult });

    const accountId = accountIdFromPath(pathname);
    if (accountId) {
        const entry = getInspectToken(accountId);
        if (entry) {
            try {
                await enterInspectFromEntry(accountId, entry);
            } catch (error) {
                // Inspect re-entry is best-effort: a failed exchange/account
                // call must not reject bootstrap, or the index.tsx catch clears
                // the base session and logs the admin out. Fall through to the
                // already-authenticated base session (normal mode) instead.
                console.error("Failed to resume inspect mode", error);
            }
        }
    }
    return "app";
};
